import api from './interceptor'
export const createOrder = async (portfolioId, payload) => (await api.post(`/portfolios/${portfolioId}/orders`, { order: payload })).data
export const fetchOrders = async (portfolioId) => (await api.get(`/portfolios/${portfolioId}/orders`)).data